export type MarkPrices = {
  from_token: number;
  native_token: number;
};
